import React from 'react'
import './headerBlog.css';

function HeaderBlog() {
  return (
      <section id='home' className='section_headerBlog'>
        <div className='container headerBlog_main'>
          {/* <h1>Blog</h1> */}

           <div className='col-lg-6 col-md-12 col-sm-12 headerBlog_wrapper'>
              <div className='headerBlogPage_info'>Published on: Feb 17, 2025</div>
          <p className='headerBlogPage_info'>Author: Ponos Technology</p>
          <h2 className='headerBlogPage_title'>Commoditizing <span className='nowrap'>Zero-Knowledge</span> Proofs: <span className='nowrap'>FPGA-Driven</span> <span className='nowrap'>SW-HW</span> <span className='nowrap'>Co-Design</span> as a Path to ASIC Acceleration</h2>
           </div>
         
        </div>
    </section>
  )
}

export default HeaderBlog
